import dashboard4APIsService from "../dashboard4APIs";
import { createDataHook } from "../../helpers/util";
import { GOOGLE_CHARTS_TYPES } from "../../consts/graphs";

const useFetchDashboard4Data = createDataHook(
  dashboard4APIsService,
  (filters, params, controller, apiService = dashboard4APIsService) => ({
    fetchSummaryCardsData: () =>
      apiService.fetchSummaryCardsData(filters, controller.signal),
    fetchLoginsByMonthData: () =>
      apiService.fetchLoginsByMonthData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BAR },
        controller.signal
      ),
    fetchLoginsByDayData: () =>
      apiService.fetchLoginsByDayData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.BAR },
        controller.signal
      ),
    fetchLoginsByTimeData: () =>
      apiService.fetchLoginsByTimeData(
        { ...params, chartType: GOOGLE_CHARTS_TYPES.AREACHART },
        controller.signal
      ),
  }),
  { preflight: "shared" }
);

export default useFetchDashboard4Data;
